module.exports = __webpack_public_path__ + "img/00053.ae12e008.webp";